import { BiInfoCircle } from "react-icons/bi";
import { ReactNode } from "react";

import styles from "./styles.module.scss";
import classNames from "classnames";
import VLTooltip from "views/uikit/VLTooltip";

interface QueryModalTitleProps {
  info?: string;
  icon: ReactNode;
  children: ReactNode;
}

export default function QueryModalTitle({
  icon,
  info,
  children,
}: QueryModalTitleProps) {
  return (
    <div className={styles.queryModalTitle}>
      <div
        className={classNames(styles.icon, "queryModalTitleIcon")}
        data-testid="query-modal-title-icon"
      >
        {icon}
      </div>
      <span
        className={classNames(
          styles.queryModalTitleContainer,
          "queryModalTitleContainer",
        )}
      >
        {children}
      </span>
      {info && (
        <VLTooltip title={info}>
          <span className={classNames(styles.info, "queryModalInfo")}>
            <BiInfoCircle />
          </span>
        </VLTooltip>
      )}
    </div>
  );
}
